import type { ReactNode } from "react";
import type { HintOption } from "../../help/fieldHints";
import { statusTitle } from "../../help/fieldHints";

/** Human label for a status key: the matching option's label, else "pending approval" for "pending_approval". */
export function statusText(status: string | null | undefined, options?: HintOption[]): string {
  if (!status) return "—";
  const raw = status.trim().toLowerCase();
  const hit = options?.find((item) => {
    const label = item.label.toLowerCase();
    return label === raw || label === raw.split("_").join(" ");
  });
  return hit?.label ?? status.split("_").join(" ");
}

/** Status chip with a hover title explaining what that status means. */
export function StatusBadge({
  status,
  options,
  className,
  children,
}: {
  status: string | null | undefined;
  options?: HintOption[];
  className?: string;
  children?: ReactNode;
}) {
  const label = children ?? statusText(status, options);
  const tone = status || "";
  return (
    <span
      className={className ?? `crm-badge${tone ? ` crm-badge--${tone}` : ""}`}
      title={options ? statusTitle(options, status) : undefined}
    >
      {label}
    </span>
  );
}
